import React from "react";
import { Button, Col, Form, Radio, Row, Select } from "antd";

import { FInput, FSelect } from "../../common/form/index.js";
import { observer } from "mobx-react";
import { getSnapshot } from "mobx-state-tree";

import { removeEmojis } from "../../utils/index";
let isImeOn = false; // IME 入力中フラグ

// 文字数制限を超えているか
let isNameTooLong = false;
const NameLimit = 10;

const Option = Select.Option;
const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

const sentences = {
  "1": {
    option: "2人の共通の友人からの推薦文",
    label: "2人の共通の友人のお名前をご記入ください。",
    radios: [
      "ノーベル夫婦賞最有力候補作。",
      "ごちそうさまです。",
      "全オレが泣いた。。",
      "こいつはスゲーや。",
      "エモい！キモい！",
      "R-18指定。"
    ]
  },
  "2": {
    option: "あなたのご両親からの推薦文",
    label: "あなたのご両親(どちらか)のお名前をご記入ください。",
    radios: [
      "息子史上最高傑作。",
      "親の顔が見てみたいわ。",
      "息子をこんないい男に育てた覚えはありません。"
    ]
  },
  "3": {
    option: "相手のご両親からの推薦文",
    label: "相手のご両親(どちらか)のお名前をご記入ください。",
    radios: [
      "いい男をつかまえたな。",
      "89点。"
    ]
  },
  "4": {
    option: "メディアからの推薦文",
    label: "",
    radios: [
      "全米がどよめいた。",
      "あの迷作が待望の書籍化決定!!",
      "あの「フラダンスの犬」を凌ぐ感動作!!!",
      "あなたはこの衝撃についてこれるか。",
      "バカデミー賞５部門ノミネート!!!"
    ]
  }
};

const blurbTextToFirstSelectIndex = b =>
  b <= sentences["1"].radios.length
    ? "1"
    : b <= sentences["1"].radios.length + sentences["2"].radios.length
      ? "2"
      : b <=
        sentences["1"].radios.length +
        sentences["2"].radios.length +
        sentences["3"].radios.length
        ? "3"
        : "4";

const blurbTextToSecondSelectIndex = b =>
  b <= sentences["1"].radios.length
    ? b - 1
    : b <= sentences["1"].radios.length + sentences["2"].radios.length
      ? b - sentences["1"].radios.length - 1
      : b <=
        sentences["1"].radios.length +
        sentences["2"].radios.length +
        sentences["3"].radios.length
        ? b - sentences["1"].radios.length - sentences["2"].radios.length - 1
        : b -
        sentences["1"].radios.length -
        sentences["2"].radios.length -
        sentences["3"].radios.length -
        1;

const getBlurbTextId = (sentenceId, radioId) => {
  let blurbTextId = 1;

  const nbRadioOne = sentences[1].radios.length;
  const nbRadioTwo = sentences[2].radios.length;
  const nbRadioThree = sentences[3].radios.length;

  if (sentenceId === "1") {
    blurbTextId += radioId;
  } else if (sentenceId === "2") {
    blurbTextId += nbRadioOne + radioId;
  } else if (sentenceId === "3") {
    blurbTextId += nbRadioOne + nbRadioTwo + radioId;
  } else if (sentenceId === "4") {
    blurbTextId += nbRadioOne + nbRadioTwo + nbRadioThree + radioId;
  }

  return blurbTextId;
};

// const adapt = (story, book) => story.replace(/△△/g, book.creatorName);

class Panflet extends React.Component {
  state = {
    name: "",
    radioSelected: -1,
    saved: false,
    selected: undefined
  };

  handleSaving = () => {
    this.props.book.changeBlurbName(this.state.name);
    this.props.book.changeBlurbText(
      getBlurbTextId(this.state.selected, this.state.radioSelected)
    );
    this.props.order.nextStep();
    this.setState({ saved: true });
  };

  handleSelectChange = s => {
    isNameTooLong = false;
    this.setState({ name: "", radioSelected: 0, selected: s });
  };
  handleRadioChange = e => {
    const v = e.target.value;
    const s = this.state.selected;
    this.setState({ radioSelected: v, saved: false });
  };
  handleTextChange = e => {
    let name = e.target.value;
    if(!isImeOn) {
      name = removeEmojis(name); // 絵文字があれば除去
    }
    isNameTooLong = name.length > NameLimit;
    this.setState({ name, saved: false });
  }
  // 入力フォームの onChange イベントを IME ON のときに無視する
  // https://maku.blog/p/cv6fpx7/
  handleTextCompositionStart = () => {
    // console.log('handleTextCompositionStart');
    isImeOn = true; // IME 入力中フラグを ON
  }
  handleTextCompositionEnd = e => {
    // console.log('handleTextCompositionEnd');
    isImeOn = false; // IME 入力中フラグを OFF
    this.handleTextChange(e);
  }

  componentWillMount() {
    if (this.props.book) {
      const { blurbName, blurbText } = this.props.book;
      if (blurbName !== "") this.setState({ name: blurbName });
      if (blurbText !== 0) {
        this.setState({
          radioSelected: blurbTextToSecondSelectIndex(blurbText),
          selected: blurbTextToFirstSelectIndex(blurbText)
        });
      }
    }
  }

  render() {
    const values = sentences,
      s = this.state.selected,
      rs = this.state.radioSelected,
      current = values[this.state.selected],
      { book, setpImage } = this.props;

    return (
      <div className="panflet">
        <div className="pd-15">
          <img
            style={{ width: "100%" }}
            src={require(`../../imgs/${setpImage}`)}
          />
          <div className="step m-t25">
            <div className="step-title">{"STEP 1"}</div>
            <div className="step-txt">{"推薦人を選んでください。"}</div>
          </div>

          <Form layout="vertical">
            <Row>
              <Col span={24} className="first-choice">
                <FSelect
                  onChange={this.handleSelectChange}
                  placeholder="推薦人/推薦文の選択"
                  style={{ marginTop: "20px" }}
                  value={this.state.selected}
                  size="large"
                >
                  {Object.keys(values).map((k, idx) => (
                    <Option key={idx} value={k}>
                      {values[k].option}
                    </Option>
                  ))}
                </FSelect>
              </Col>
              {current
                ? [
                  <Col key={0} span={24} style={{ marginBottom: "20px" }}>
                    <div className="step m-t25">
                      <div className="step-title">{"STEP 2"}</div>
                      <div className="step-txt">
                        {"推薦文を選択してください。"}
                      </div>
                    </div>
                    <br />
                    <RadioGroup
                      onChange={this.handleRadioChange}
                      value={this.state.radioSelected}
                    >
                      {current.radios.map((v, idx) => (
                        <Radio key={idx} style={radioStyle} value={idx}>
                          {v}
                        </Radio>
                      ))}
                    </RadioGroup>
                  </Col>,
                  this.state.selected !== "4" ? (
                    <div key={1}>
                      <div className="step m-t25">
                        <div className="step-title">{"STEP 3"}</div>
                        <div className="step-txt">
                          {"下記●●●●●●部分に入る推薦人のお名前（敬称含め10文字以内）を入力してください。"}
                        </div>
                      </div>
                      <br />
                      <div data-warning={isNameTooLong}>
                        <Col span={24}>
                          <FInput
                            onChange={this.handleTextChange}
                            onCompositionStart={this.handleTextCompositionStart}
                            onCompositionEnd={this.handleTextCompositionEnd}
                            size="large"
                            value={this.state.name}
                          />
                        </Col>
                      </div>
                    </div>
                  ) : (
                    <div key={1} />
                  ),
                  <Col
                    key={2}
                    span={24}
                    className="bandPreview"
                  >
                    <img
                      className="bandPreview_image"
                      src={require(`../../imgs/male_to_female/band_${this.state.radioSelected === -1 ? "0" : ~~getBlurbTextId(this.state.selected, this.state.radioSelected)}.png`)}
                      alt=""
                    />
                    <img
                      className="bandPreview_bg"
                      src={require(`../../imgs/male_to_female/bg_panflet_male_to_female.png`)}
                      alt=""
                    />
                    {this.state.selected !== "4"
                      ? [
                        <div key={3} className="bandPreview_text">
                          あの
                          {this.state.name.length
                          ? this.state.name
                          : "●●●●●●"}
                          が絶賛！
                        </div>
                      ]
                      : null}
                  </Col>
                ]
                : null}
            </Row>
          </Form>
        </div>
        <div className="pd-15">
          <div className="btn-wrap">
            <button
              onClick={this.handleSaving}
              className="btn product-btn"
              disabled={
                (this.state.name === "" && this.state.selected !== "4") ||
                this.state.radioSelected === -1 ||
                isNameTooLong
              }
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(Panflet);



// WEBPACK FOOTER //
// ./src/components/steps/Panflet.js